import Loadable from "react-loadable";
import OptionsWithoutRender = LoadableExport.OptionsWithoutRender;

interface ComponentProps {
  message: string;
}

type Props = ComponentProps;

const loadableOptions: OptionsWithoutRender<Props> = {
  loader: () => import("../../manage-pitch").then((module) => module.ConnectInvestorModal) as Promise<any>,
  loading: () => null,
};

export const ConnectInvestorModal = Loadable(loadableOptions);

